module.exports = __webpack_public_path__ + "static/img/weather9.0752c32.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/weather9.png
// module id = yA/6
// module chunks = 0